import { useTranslation } from 'react-i18next';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import { useLoadRoutesWitoutTaskData } from './useLoadRoutesWithoutTaskData';

export const useRoutesWithoutTaskPage = () => {
  const { t } = useTranslation();

  useLoadRoutesWitoutTaskData();

  const { mobileOrTablet } = useResponsiveQuery();

  const responsivePadding = mobileOrTablet ? 6 : 12;

  return { responsivePadding, t, mobileOrTablet };
};
